import styled, { keyframes } from "styled-components";

const subtleFloat = keyframes`
	0%, 100% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-3px);
	}
`;

const subtlePulse = keyframes`
	0%, 100% {
		box-shadow: 0 16px 30px rgb(0 0 0 / 10%);
	}
	50% {
		box-shadow: 0 18px 35px rgb(0 0 0 / 15%);
	}
`;

export const FixedDonateButton = styled.button`
	position: fixed;
	top: 1rem;
	right: 1rem;
	z-index: 1000;
	background: var(--color-primary);
	color: #fff;
	font-size: 1rem;
	font-weight: 700;
	border: 1px solid var(--color-border);
	border-radius: 4px;
	padding: 10px 20px;
	cursor: pointer;
	transition:
		opacity 0.3s ease-in-out,
		background-color 0.3s ease-in-out,
		border 0.3s ease-in-out,
		transform 0.3s ease-in-out;
	box-shadow: 0 16px 30px rgb(0 0 0 / 10%);
	animation:
		${subtleFloat} 4s ease-in-out infinite,
		${subtlePulse} 4s ease-in-out infinite;

	&:hover,
	&:active,
	&:focus {
		color: #fff;
		border: 1px solid var(--color-primary-hover);
		background-color: var(--color-primary-hover);
		animation-play-state: paused;
		transform: scale(1.05);
	}

	@media screen and (max-width: 414px) {
		padding: 8px 16px;
		font-size: 0.875rem;
	}
`;

export const HiddenPayPalContainer = styled.div`
	position: absolute;
	left: -9999px;
	top: -9999px;
	opacity: 0;
	pointer-events: auto;
	width: 1px;
	height: 1px;
	overflow: hidden;
`;
